import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://customer-assets.emergentagent.com/job_e27ebe9b-30d6-413b-8ace-1878381002bd/artifacts/5ip4s9xa_WhatsApp%20Image%202026-03-03%20at%2009.28.46%20%282%29.jpeg" 
              alt="ATW Against the Wind Logo" 
              className="h-20 w-auto object-contain"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              Reviews
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-brand-blue hover:bg-brand-blue-700 text-white px-6"
            >
              Get a Free Quote
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;